import { Box } from '@mui/material';
import { useCaseFieldData } from '../../../hooks/useCaseField';
import type { FieldMode } from '../../../hooks/useCaseField';
import { CaseSwitchField, CaseTextField, CaseChipListField } from '../../fields';
import AntibioticGrid from './AntibioticGrid';

interface PreopSectionProps {
  mode: FieldMode;
}

const PreopSection: React.FC<PreopSectionProps> = ({ mode }) => {
  const data = useCaseFieldData(mode);

  if (!data.preop) return null;

  return (
    <Box sx={{ mb: 2.5 }}>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, auto)', gap: 1.5, mb: 1.5, alignItems: 'center' }}>
        <CaseSwitchField mode={mode} label="NKDA"
          getValue={d => d.preop?.nkda ?? false}
          getUpdate={(v, d) => ({ preop: { ...d.preop!, nkda: v } })} />
        <CaseSwitchField mode={mode} label="SCD"
          getValue={d => d.preop?.scd ?? false}
          getUpdate={(v, d) => ({ preop: { ...d.preop!, scd: v } })} />
        <CaseSwitchField mode={mode} label="TED Hose"
          getValue={d => d.preop?.tedHose ?? false}
          getUpdate={(v, d) => ({ preop: { ...d.preop!, tedHose: v } })} />
        <CaseSwitchField mode={mode} label="IV Start"
          getValue={d => d.preop?.ivStart ?? false}
          getUpdate={(v, d) => ({ preop: { ...d.preop!, ivStart: v } })} />
        <CaseSwitchField mode={mode} label="Pregnancy Test"
          getValue={d => d.preop?.pregnancyTest ?? false}
          getUpdate={(v, d) => ({ preop: { ...d.preop!, pregnancyTest: v } })} />
      </Box>

      <CaseChipListField mode={mode} label="Allergies"
        getItems={d => d.preop?.allergies ?? []}
        getUpdate={(items, d) => ({ preop: { ...d.preop!, allergies: items } })} />
      <AntibioticGrid mode={mode} />
      <CaseTextField mode={mode} label="Other Orders" fullWidth multiline minRows={2}
        getValue={d => d.preop?.otherOrders ?? ''}
        getUpdate={(v, d) => ({ preop: { ...d.preop!, otherOrders: v } })} />
    </Box>
  );
};

export default PreopSection;
